import TopBar from '../../common/TopBar';
import { Button, LinearProgress } from '@mui/material';
import DocumentListGroup from './DocumentsListGroup';
import ErrorPage from '../../common/ErrorPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import TitleDetails from './TitleDetails';
import errorResponses from '../../../errorResponses';
import useGlynt from '../../hooks/useGlynt';
import useSetOrg from '../../hooks/useSetOrg';
import { Link } from 'react-router';
import { getIdFromUrl } from '../../../utils/getIdFromUrl';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useSetTitle } from '../../hooks/useSetTitle';

function ExtractionBatchDetailsGroup() {
  const { dpid, id, gid } = useParams<{
    dpid: string;
    id: string;
    gid: string;
  }>();

  if (!id || !gid) {
    throw new Error('id or gid is not defined');
  }

  const { loading, error } = useSetOrg(dpid);
  const glynt = useGlynt(dpid);

  const {
    data: dataPool,
    isError: errorDataPool,
    isPending: loadingDataPool,
  } = useQuery({
    queryKey: ['dataPool'],
    queryFn: async () => await (await glynt).dataPool.retrieve()
  });

  const {
    data: extractionBatch,
    isPending,
    isError,
  } = useQuery({
    queryKey: ['extractionBatch', id],
    queryFn: async () => await (await glynt).extractionBatch.retrieve(id)
  });

  useSetTitle(extractionBatch?.label ? `Details - ${extractionBatch?.label}` : '...');

  if (isPending || loadingDataPool || loading) {
    return <LinearProgress />;
  }

  if (error || errorDataPool) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  } else if (isError) {
    return <ErrorPage error={errorResponses.failedToLoadExtractionBatch} />;
  }

  let groupKeys =
    (extractionBatch && Object.keys(extractionBatch.extractions_by_training_set)) || [];
  // handle unclassified/None group
  let currentGroupKey = groupKeys?.find((gk) => getIdFromUrl(gk) === gid) || 'None';

  const extractionIds =
    (extractionBatch &&
      extractionBatch.extractions_by_training_set[currentGroupKey]?.map((url: string) =>
        getIdFromUrl(url)
      )) ||
    [];

  // console.log({ extractionIds });
  return (
    <div id="extraction-batches-details">
      <TopBar />
      {extractionBatch ? (
        <div style={{ margin: 30 }}>
          <TitleDetails
            extractionBatch={extractionBatch}
            groupId={gid}
            cypressId="lbl-extraction-batch-name"
          />
          <div style={{ margin: 15 }}>
            <Link
              to={`/data-pools/${dpid}/extraction-batches`}
              style={{ textDecoration: 'none', float: 'left' }}
            >
              <Button id="extraction-batches-details-back" variant="contained" color="primary">
                <KeyboardArrowLeft />
                Back
              </Button>
            </Link>
          </div>

          <DocumentListGroup
            extractionBatch={extractionBatch}
            extractionIds={extractionIds}
            groupId={gid}
          />
        </div>
      ) : null}
    </div>
  );
}

export default ExtractionBatchDetailsGroup;
